export const filter = (() => {
    var filters = document.querySelectorAll(".filter-select");

    Array.from(filters).forEach((filter) => addEL(filter));

    function addEL(filter) {
        if (!filter.hasAttribute("aria-controls")) return;
 

        filter.addEventListener("change", function () {

            let target = document.getElementById(filter.getAttribute("aria-controls"));

            for (const child of target.children) {
                let article = child.children[0];

                let selected = true;


                Array.from(filters).forEach((filter) => {
                    if (!selected) return;

                    let cat = filter.id;

                    if (filter.value === "Alla") {
                        selected = true;
                    }
                    else if (article.getAttribute("data-" + cat).indexOf(filter.value) < 0) {
                        selected = false;
                    }
                });
                if (selected) {
                    child.classList.remove("listing-listitem--hidden");
                    child.setAttribute("aria-hidden", "false");
                } else {
                    child.classList.add("listing-listitem--hidden");
                    child.setAttribute("aria-hidden", "true");

                }


            }

        });
    }

})();